import React from 'react';
import { Section } from './ui/Section';
export function TransformationSection() {
  return <Section className="bg-navy-800" dark={true} data-id="element-230">
      <div className="max-w-3xl mx-auto text-center space-y-12" data-id="element-231">
        <h2 className="text-4xl md:text-5xl font-serif text-cream-50" data-id="element-232">
          Imagina esto en su lugar
        </h2>

        <div className="space-y-8 text-xl md:text-2xl font-light leading-relaxed text-cream-100/90" data-id="element-233">
          <p data-id="element-234">
            Te metes en la cama… y tu cuerpo realmente{' '}
            <span className="italic text-gold-400" data-id="element-235">se suelta.</span>
          </p>
          <p data-id="element-236">Sigues teniendo pensamientos—pero no te atrapan.</p>
          <div className="py-8 border-y border-navy-700 space-y-4" data-id="element-237">
            <p data-id="element-238">Si te despiertas a las 3am, no entras en pánico.</p>
            <p className="font-medium text-cream-50" data-id="element-239">Sigues un guión.</p>
            <p className="font-medium text-cream-50" data-id="element-240">Te calmas.</p>
            <p className="font-medium text-cream-50" data-id="element-241">Vuelves a dormirte.</p>
          </div>
          <p data-id="element-242">
            Y por la mañana, te sientes más estable—no porque la vida sea
            perfecta, sino porque finalmente descansaste.
          </p>
        </div>
      </div>
    </Section>;
}